const ENDPOINTS = {
  updatePinnedCard: () => "/api/update-pinned-card",
  updatePinnedCardsDisplayOrder: () => "/api/update-pinned-card/display-order",
};

export { ENDPOINTS };
